export default __webpack_public_path__ + "images/background--admissions-and-requirements.jpg";